var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlarmOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6416 17.627H22.6416V19.627H2.6416V17.627H4.6416V10.627C4.6416 6.20867 8.22332 2.62695 12.6416 2.62695C17.0599 2.62695 20.6416 6.20867 20.6416 10.627V17.627ZM18.6416 17.627V10.627C18.6416 7.31324 15.9553 4.62695 12.6416 4.62695C9.32789 4.62695 6.6416 7.31324 6.6416 10.627V17.627H18.6416ZM9.6416 21.627H15.6416V23.627H9.6416V21.627Z",
    fill: "#193975"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1816,
    cy: 5.62695,
    r: 3.5,
    fill: "#E6003E",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmOn);
export default __webpack_public_path__ + "static/media/icon_alarm_on.15d83cb2a5051014c7a49a4ede1bfa0e.svg";
export { ForwardRef as ReactComponent };